"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLabelTooltip = void 0;
const react_1 = __importDefault(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const useLabelTooltip = (labelTooltip) => {
    if (!labelTooltip)
        return;
    if (typeof labelTooltip === 'string') {
        return labelTooltip;
    }
    return (react_1.default.createElement(wl_ui_kit_1.Link, { target: "_blank", href: labelTooltip.url }, labelTooltip.name));
};
exports.useLabelTooltip = useLabelTooltip;
//# sourceMappingURL=useLabelTooltip.js.map